import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { setDevMode } from "../../api/aquastrong";

const DevRoute = () => {
  const { isAuth, isLoading, user } = useAuth();

  setDevMode(true);

  if (isLoading) return null;
  if (!isAuth) return <Navigate to="/" replace />;

  const isAdmin = user?.roles?.includes("ROLE_ADMIN");
  if (!isAdmin) return <Navigate to="/" replace />;

  return <Outlet />;
};

export default DevRoute;